import { type PropsWithChildren } from 'react';

import { MobileAppContextProvider } from '~/hooks/mobileApp';
import AppMarketHomeLink from '~/layouts/AppMarketHomeLink';

import { HomeNavigation } from './HomeNavigation';

export function HomeLayout({ children }: PropsWithChildren) {
  return (
    <main className="m-auto flex min-h-full max-w-3xl flex-col bg-gray-000 ios-safe-bottom">
      <MobileAppContextProvider LinkComponent={AppMarketHomeLink}>
        <HomeNavigation />
        {children}
      </MobileAppContextProvider>
    </main>
  );
}
